import React, { useContext, useEffect, useState } from 'react';
import {
  DialogContent,
  LinearProgress,
  Button,
  Dialog,
  DialogTitle,
  IconButton,
  FormControl,
  Alert,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import { isDesktop, isMobile, isTablet } from 'react-device-detect';
import DownloadIcon from '@mui/icons-material/Download';
import { ClearIcon } from '@mui/x-date-pickers';
import { format } from 'date-fns';
import { IPickupTask } from '../../../../interfaces/delivery-company/tasks';
import { AuthContext } from '../../../../contexts/user-context/user-context';
import { API_ENDPOINT } from '../../../../configurations/global.config';
import axios from 'axios';
import CustomDialog from '../../../common/custom-dialog/custom-dialog';
import { OrderStickers } from '../../../common/waybill-printer/waybill-printer-minified';
import { UserType } from '../../../../enums/users';
import { OrgSettingsContext } from '../../../../contexts/org-settings-context';
import { PrintWaybillsMultiSizes } from '../../../common/bulk-action/print-waybills';
import { OrderType } from '../../../../interfaces/delivery-company/orders';

interface TaskWaybillsDialogProps {
  task: IPickupTask;
  onClose: () => void;
  filteredOrders?: OrderType[] | null; // null means all orders, array means specific orders
}

function TaskWaybillsDialog({
  task,
  onClose,
  filteredOrders,
}: TaskWaybillsDialogProps) {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { user, config } = useContext(AuthContext);

  const [mode, setMode] = useState<'stickers' | 'pages'>(
    user?.type == UserType.MERCHANT ? 'pages' : 'stickers'
  );
  const {settings} = useContext(OrgSettingsContext)

  const [taskData, setTaskData] = useState<IPickupTask>();

  useEffect(() => {
    // Skip fetching task data if we already have filtered orders
    if (filteredOrders !== undefined) {
      return;
    }
    if (task != null) {
      // fetch task orders only when no filtered orders are provided
      setIsLoading(true);
      const getTaskData = async () => {
        const endpoint = `${API_ENDPOINT}/api/v1/pickup-task/${task.id}/`;
        try {
          console.log(endpoint);
          const response = await axios.get<IPickupTask>(endpoint, config);
          console.log(response);
          setTaskData(response.data);
        } catch (error) {
          console.log(error);
        }
        setIsLoading(false);
      };
      getTaskData();
    }
  }, [task?.id, filteredOrders]);

  return (
    <CustomDialog open={isOpen} onClose={onClose} maxWidth="md">
      <DialogTitle>
        <div
          style={{
            textAlign: 'right',
            width: '100%',
          }}
        >
          <IconButton
            style={{}}
            onClick={() => {
              onClose && onClose();
              setIsOpen(false);
            }}
          >
            <ClearIcon color="primary" fontSize="large" />
          </IconButton>
          <div style={{ width: '100%', textAlign: 'center' }}>
            Task Waybills
          </div>
        </div>
      </DialogTitle>

      <DialogContent
        style={
          (isDesktop || isTablet)
            ? { width: 'auto', height: 'auto', textAlign: 'center' }
            : {}
        }
      >
        {isLoading ? (
          <>
            Getting task details ... <br />
            <LinearProgress />
          </>
        ) : (
          <>
            {/* If we have filtered orders, use them directly without waiting for taskData */}
            {filteredOrders !== undefined && filteredOrders !== null ? (
              <PrintWaybillsMultiSizes
                pickupTaskId={task.id}
                orders={filteredOrders}
                onClose={onClose}
              />
            ) : taskData ? (
              <PrintWaybillsMultiSizes
                pickupTaskId={task.id}
                orders={taskData.orders}
                onClose={onClose}
              />
            ) : (
              <Alert severity="error">
                Failed to get task data. Please contact us.
              </Alert>
            )}
          </>
        )}
      </DialogContent>
    </CustomDialog>
  );
}

export default TaskWaybillsDialog;